import { Tag } from 'antd'
import BigNumber from 'bignumber.js'
import React from 'react'
import { COLORS } from '../../../constants'
import { TagWrap } from './styles'
import Contracts from '../../PositionColumns/Contracts'
import EntryTime from '../../PositionColumns/EntryTime'
import Price from '../../PositionColumns/Price'
import PnlPrice from '../../PositionColumns/PnlPrice'
import Contracts2 from '../../PositionColumns/Contracts2'
import { Text } from '../../../../styles/reactnative'

export const column_closedpnl = mutate => {
	return [
		{
			title: '번호',
			dataIndex: 'id',
			key: 'id',
			align: 'center',
			width: 70,
			render: (text, record) => <Text>{text}</Text>,
		},
		{
			title: '주문일',
			align: 'center',
			dataIndex: 'created_at',
			key: 'created_at',
			width: 65,
			render: (text, record) => (
				<div style={{ 
					textAlign: 'center',
					lineHeight: 1.2
				}}>
					<EntryTime
						time={record.created_at}
						format="YY-MM-DD"
						style={{ display: 'block', fontSize: 12, fontWeight: 'normal', color: '#333' }}
					/>
					<EntryTime
						time={record.created_at}
						format="HH:mm:ss"
						style={{ display: 'block', fontSize: 12, fontWeight: 'normal', color: '#333' }}
					/>
				</div>
			),
		},
		{
			title: '체결일',
			align: 'center',
			dataIndex: 'traded_at',
			key: 'traded_at',
			width: 65,
			render: (text, record) => (
				<div style={{ 
					textAlign: 'center',
					lineHeight: 1.2
				}}>
					<EntryTime
						time={record.traded_at}
						format="YY-MM-DD"
						style={{ display: 'block', fontSize: 12, fontWeight: 'normal', color: '#333' }}
					/>
					<EntryTime
						time={record.traded_at}
						format="HH:mm:ss"
						style={{ display: 'block', fontSize: 12, fontWeight: 'normal', color: '#333' }}
					/>
				</div>
			),
		},
		{
			title: '종목',
			dataIndex: 'pairs',
			key: 'pairs',
			align: 'center',
			width: 150,
			render: (text, record) => <Contracts2 data={record} showtrade={true} />,
		},
		{
			title: '진입가',
			dataIndex: 'price',
			key: 'order_price',
			align: 'center',
			width: 80,
			render: (text, record) => (
				<Price
					price={record?.order_price}
					ep_id={record?.exchange_pairs_id}
				/>
			),
		},
		{
			title: '평단가',
			dataIndex: 'pos_price',
			key: 'pos_price',
			align: 'center',
			width: 80,
			render: (text, record) => (
				<Price
					price={record?.pos_price}
					ep_id={record?.exchange_pairs_id}
				/>
			),
		},
		{
			title: '수량',
			dataIndex: 'amount',
			key: 'amount',
			align: 'center',
			width: 70,
			render: (text, record) => (
				<div
					style={{
						whiteSpace: 'nowrap',
					}}>
					{BigNumber(record?.amount || 0).toFormat(0)}
				</div>
			),
		},
		{
			title: '손익',
			dataIndex: 'pnl_price',
			key: 'pnl_price',
			align: 'center',
			render: (text, record) => (
				<PnlPrice price={text} krw={true} dp={0} />
			),
		},
		{
			title: '수수료',
			dataIndex: 'fee_price',
			key: 'fee_price',
			align: 'center',
			render: (text, record) => (
				<PnlPrice
					price={-Math.abs(record?.fee_price)}
					krw={true}
					dp={0}
				/>
			),
		},
		{
			title: '예수금',
			dataIndex: 'balance_futures',
			key: 'balance_futures',
			align: 'center',
			render: (text, record) => (
				<div
					style={{
						whiteSpace: 'nowrap',
					}}>
					{BigNumber(record?.balance_futures || 0).toFormat(0)}
				</div>
			),
		},
	]
}
